import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

export const StyledImg = styled(GatsbyImage)`
  height: 300px;
  width: 100%;
`;
